<template>
  <div class="hui-helper-container">
    <TrapezoidBgImg @click.native="handleHuiHelperClick">慧助手</TrapezoidBgImg>
  </div>
</template>

<script>
import TrapezoidBgImg from './TrapezoidBgImg.vue'
import { addPageTagAndNavigate } from '@/services/microFeUtil/pageTagUtils'
import { getBaseAppProtocolHost } from '@/services/microFeUtil'

export default {
  components: {
    TrapezoidBgImg,
  },
  methods: {
    handleHuiHelperClick() {
      addPageTagAndNavigate(`${getBaseAppProtocolHost()}/s/bi/#/settings/gpt`)
    },
  }
}
</script>

<style lang="scss" scoped>
.hui-helper-container {
  display: inline-block;
}
</style>
